<template lang="html">

    <v-app-bar
            app
            color="accent"
            dark
    >
      <div class="d-flex align-center diceboard_title">
        <div>Diceboard</div>
      </div>

      <v-tabs align-with-title>
        <v-tab to="/admin/games">Spiele</v-tab>
        <v-tab to="/admin/translations">Übersetzungen</v-tab>
        <v-tab to="/admin/genres">Genres</v-tab>
        <v-tab to="/admin/publisher">Verläge</v-tab>
      </v-tabs>

      <v-spacer></v-spacer>

      <template>
        <router-link to="/">
          <v-btn class="mr-1 button">
            Frontend
          </v-btn>
        </router-link>
      </template>
    </v-app-bar>

</template>

<script lang="js">

  export default  {
    name: 'admin-header',
    props: [],
    mounted () {

    },
    data () {
      return {
      }
    },
    methods: {

    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .admin-header {

  }
</style>
